/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';
import { PageSection } from 'bundles/enterprise-ui/components/PageSection';

type Props = {
  pageName: string;
};

export const OrgPageBannerV2: React.FC<Props> = ({ pageName }) => {
  const thirdPartyOrganization = useThirdPartyOrganization();
  return (
    <PageSection
      css={css`
        padding: 24px 0;
      `}
    >
      <Grid container spacing={16} direction="row" wrap="nowrap" data-e2e="org-page-banner">
        <Grid item css={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <Typography2 variant="titleSmall" component="h1">
            {thirdPartyOrganization.name}&nbsp;{pageName}
          </Typography2>
        </Grid>
      </Grid>
    </PageSection>
  );
};
